import {
  GET_USER_FEATURES_SET_REQUEST,
  GET_USER_FEATURES_SET_SUCCESS,
  GET_USER_FEATURES_SET_FAILURE
} from './constants';
import _ from './utils';

let initialState = {
  featureList: {},
  featureListLoading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_FEATURES_SET_SUCCESS: {
      return {
        ...state,
        message: null,
        messageType: '',
        featureList: _.get(action, 'data.output') || {},
        featureListLoading: false
      };
    }
    case GET_USER_FEATURES_SET_REQUEST:
      return { ...state, message: null, messageType: '', featureListLoading: true };
    case GET_USER_FEATURES_SET_FAILURE:
      return { ...state, message: action.error, messageType: 'error', featureListLoading: false };
    default:
      return state;
  }
}

export default reducer;
